import * as React from "react"
import styled from 'styled-components';

interface IProps {
  title: string
}

const Chapter: React.FC<IProps> = ({ title }) => {
  return (
    <ChapterWrapper>
      <span>{title}</span>
    </ChapterWrapper>
  )
}

const ChapterWrapper = styled.h3`
  height: 43px;
  margin-bottom: 15px;
  border-left: #0679d7 solid 6px;
  background: #005daa -webkit-gradient(linear, left top, left bottom, color-stop(0.88, #004379), color-stop(0, #075ca1));
  background: #005daa -webkit-linear-gradient(top, #075ca1 0%, #004379 88%);
  background: #005daa -moz-linear-gradient(top, #075ca1 0%, #004379 88%);
  background: #005daa -o-linear-gradient(top, #075ca1 0%, #004379 88%);
  background: #005daa -ms-linear-gradient(top, #075ca1 0%, #004379 88%);
  background: #005daa linear-gradient(to bottom, #075ca1 0%, #004379 88%);
  & ::before {
    content: "";
    margin-left: 2px;
    border-left: #0679d7 solid 2px;
    height: 100%;
    display: inline-block;
  }
  &  span {
    color: #fff;
    font-size: 1.4em;
    display: inline-block;
    padding: 10px;
    margin: 0;
    height: 100%;
    top: -12px;
    position: relative;
    line-height: 1.4em;
  }
`

export default Chapter